import Grid from "@material-ui/core/Grid";
import React from "react";

// fitHeight makes the actions fill the panel instead of stacking to their
// natural height. The fit layout needs a definite height to divide, and it
// must not sit inside a Grid container: a Grid container is a flex row, and a
// plain child of one collapses to its content width instead of filling. So
// the fit path gets a plain full-size wrapper rather than nested Grids.
const PlayInitialStep = ({ additionalActions, fitHeight = false }) => {
	if (fitHeight) {
		return (
			<div style={{ height: "100%", width: "100%" }}>{additionalActions}</div>
		);
	}

	return (
		<Grid container spacing={1} justifyContent="center">
			<Grid item xs={12}>
				<Grid container>{additionalActions}</Grid>
			</Grid>
		</Grid>
	);
};

export default PlayInitialStep;
